import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiOrganizationLink,
  ApiOrganizationLinkPayload,
  ApiOrganizationLinksUpdateSortPayload,
} from "@/types/organization-link.types.ts";

export const apiOrganizationLinks = {
  getAll: () => {
    return api.get<ApiOrganizationLink[]>("/api/v1/organization-links");
  },
  create: (payload: ApiOrganizationLinkPayload) => {
    return api.post<ApiOrganizationLink>("/api/v1/organization-links", payload);
  },
  update: (id: number, payload: ApiOrganizationLinkPayload) => {
    return api.put<ApiOrganizationLink>(`/api/v1/organization-links/${id}`, payload);
  },
  updateSort: (payload: ApiOrganizationLinksUpdateSortPayload) => {
    return api.put<ApiOperationResult>("/api/v1/organization-links/sort", payload);
  },
  delete: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/organization-links/${id}`);
  },
};
